(function($, Drupal, drupalSettings) {

  var changeFormToEditInterval;

  Drupal.behaviors.checkout_components = {
    attach: function (context, settings) {

      // Required fields that needs values for ajax form state changes.
      var addressFieldsRequired = [
        '#edit-shipping-information input.address-line1',
        '#edit-shipping-information input.locality',
        '#edit-shipping-information input.postal-code',
        '.checkout-pane-billing-information input.address-line1',
        '.checkout-pane-billing-information input.locality',
        '.checkout-pane-billing-information input.postal-code',
      ];
      var guestFieldsRequired = [
        '.checkout-pane-contact-information input.form-email',
      ];

      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const dayNth = function(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1:  return "st";
          case 2:  return "nd";
          case 3:  return "rd";
          default: return "th";
        }
      }
      function setDateLabel(date) {
        if (date) {
          var dateLabel = date.split('/');
          dateLabel = new Date(dateLabel[2] + '-' + dateLabel[1] + '-' + dateLabel[0]);
          dateLabel = dayNames[dateLabel.getDay()] + ' ' + dateLabel.getDate() + dayNth(dateLabel.getDate()) + ' ' + monthNames[dateLabel.getMonth()];
          $('.form-item-shipping-information-shipping-profile-field-customer-delivery-date-x label span').text('(' + dateLabel + ')');
        }
      }

      function changeFormToEdit() {
        setRequiredFields();

        if ($('.address-book-edit-button:not(:disabled)').length) {
          $('input[name="checkout_agree_checkbox"]').prop('checked', true);
          $('.address-book-edit-button').trigger('mousedown');
        }

        if ($('.form-item-billing-information-profile-copy-fields-enable input[type="checkbox"]').is(':checked') &&
            $('.form-item-billing-information-profile-field-customer-first-name-0-value input').length) {
          $('.form-item-billing-information-profile-copy-fields-enable input[type="checkbox"]').trigger('change');
        }

        if (!$('.form-item-billing-information-profile-copy-fields-enable input[type="checkbox"]').is(':checked') &&
            !$('.form-item-billing-information-profile-field-customer-first-name-0-value input').length) {
          $('.form-item-billing-information-profile-copy-fields-enable input[type="checkbox"]').trigger('change');
        }
      }

      function setRequiredFields() {
        $('input[name="checkout_agree_checkbox"]').prop('checked', true);
        $.each(addressFieldsRequired, function(index, selector) {
          if ($(selector).val() == '') {
            $(selector).val('_____');
          }
        });
        $.each(guestFieldsRequired, function(index, selector) {
          if ($(selector).val() == '') {
            $(selector).val('customer@email.com');
          }
        });
      }

      function resetRequiredFields() {
        $('input[name="checkout_agree_checkbox"]').prop('checked', false);
        $.each(addressFieldsRequired, function(index, selector) {
          if ($(selector).val() == '_____') {
            $(selector).val('');
          }
        });
        $.each(guestFieldsRequired, function(index, selector) {
          if ($(selector).val() == 'customer@email.com') {
            $(selector).val('');
          }
        });
      }

      if ($('.layout-checkout-form .layout-region-checkout-main').length) {

        // Convert the form to the edit version.
        if ($('.address-book-edit-button:not(:disabled)').length) {
          changeFormToEditInterval = setTimeout(function () {
            changeFormToEdit();

            setTimeout(function () {
              changeFormToEdit();

              setTimeout(function () {
                changeFormToEdit();

              }, 500);
            }, 500);
          }, 500);
        }

        // Re-try converting form to edit version, in case it failed validation before the change.
        $('body').once('checkout--form-field-change').on('change', '.layout-checkout-form input', function(){
          changeFormToEdit();
        });

        // Fill required fields to allow form to ajax post.
        $('.form-item-billing-information-profile-copy-fields-enable input[type="checkbox"]').once('checkout--sort-mandatories').change(function () {
          setRequiredFields();
        });

        // Convert select lists to select2.
        if ($('select.form-select.available-profiles').length) {
          var options = {};
          options.width = Drupal.webform.select2.options.widthInline;
          options = $.extend(options, Drupal.webform.select2.options);
          $('select.form-select.available-profiles').chosen('destroy');
          $('select.form-select.available-profiles').select2(options);
        }

        // Checkout datepicker.
        var setDateAs;
        if ($('.field--name-field-customer-delivery-date').length &&
            $('.field--name-field-customer-delivery-date-x').length &&
            $('.field--name-field-customer-delivery-date-x').data('earliest-day') &&
            !$('.field--name-field-customer-delivery-date .checkout-date-picker').length) {
          var earliestDay = $('.field--name-field-customer-delivery-date-x').data('earliest-day') + 1;
          var earliestMonth = $('.field--name-field-customer-delivery-date-x').data('earliest-month') + 1;

          setDateAs = (earliestDay < 10 ? '0' : '') + earliestDay + '/' +
                      (earliestMonth < 10 ? '0' : '') +  earliestMonth + '/' +
                      $('.field--name-field-customer-delivery-date-x').data('earliest-year');
          setDateAs = setDateAs.split('/');

          $('.field--name-field-customer-delivery-date input').val(setDateAs[0] + '/' + setDateAs[1] + '/' + setDateAs[2]);
          setDateAs = $('.field--name-field-customer-delivery-date input').val();
          setDateAs = setDateAs.split('/');
          setDateLabel($('.field--name-field-customer-delivery-date input').val());

          $('.field--name-field-customer-delivery-date').append('<div class="checkout-date-picker"></div>');
          $('.field--name-field-customer-delivery-date .checkout-date-picker').datepicker({
            onSelect: function(date) {
              $('.field--name-field-customer-delivery-date input').val(date);
              setDateLabel(date);
            },
            minDate: new Date(
              $('.field--name-field-customer-delivery-date-x').data('earliest-year'),
              $('.field--name-field-customer-delivery-date-x').data('earliest-month'),
              $('.field--name-field-customer-delivery-date-x').data('earliest-day') + 1
            ),
            defaultDate: new Date(setDateAs[2] + '-' + setDateAs[1] + '-' + setDateAs[0]),
            dateFormat: 'dd/mm/yy',
            beforeShowDay: $.datepicker.noWeekends,
            firstDay: 1, // Start with Monday
          });
        }

        // Show/hide datepicker.
        $('.field--name-field-customer-delivery-date-x input').once('niche-checkout-pickdate').change(function(){
          if ($('.field--name-field-customer-delivery-date-x input:checked').val() == 'pick_day') {
            $('#shipping-information-wrapper .field--name-field-customer-delivery-date').slideDown();
            setDateLabel($('.field--name-field-customer-delivery-date input').val());

            $('.js-form-item-shipping-information-shipping-profile-field-customer-delivery-time:last label').text('AM (£30 delivery surcharge applied)');
          } else {
            $('.js-form-item-shipping-information-shipping-profile-field-customer-delivery-time:last label').text('AM (£50 delivery surcharge applied)');
            var earliestDay = $('.field--name-field-customer-delivery-date-x').data('earliest-day');
            var earliestMonth = $('.field--name-field-customer-delivery-date-x').data('earliest-month') + 1;
            var setDateAs = (earliestDay < 10 ? '0' : '') + earliestDay + '/' +
              (earliestMonth < 10 ? '0' : '') +  earliestMonth + '/' +
              $('.field--name-field-customer-delivery-date-x').data('earliest-year');
            $('.field--name-field-customer-delivery-date input').val(setDateAs);

            $('.field--name-field-customer-delivery-date .checkout-date-picker' ).datepicker('setDate', new Date(
              $('.field--name-field-customer-delivery-date-x').data('earliest-year'),
              $('.field--name-field-customer-delivery-date-x').data('earliest-month'),
              $('.field--name-field-customer-delivery-date-x').data('earliest-day')
            ) );

            $('.field--name-field-customer-delivery-date').slideUp();
            $('.form-item-shipping-information-shipping-profile-field-customer-delivery-date-x label span').text('');
          }
        });
        if ($('.field--name-field-customer-delivery-date-x input:checked').val() == 'pick_day' && !$('.field--name-field-customer-delivery-date').is(':visible')) {
          setDateAs = $('.field--name-field-customer-delivery-date-x').data('earliest-day') + '/' +
                      ($('.field--name-field-customer-delivery-date-x').data('earliest-month') < 10 ? '0' : '') +
                      $('.field--name-field-customer-delivery-date-x').data('earliest-month') + '/' +
                      $('.field--name-field-customer-delivery-date-x').data('earliest-year');
          if ($('.field--name-field-customer-delivery-date input').val()) {
            setDateAs = $('.field--name-field-customer-delivery-date input').val();
          }

          $('.field--name-field-customer-delivery-date input').val(setDateAs);
          $('.field--name-field-customer-delivery-date').show();
        }

        // Reset mandatory fields if they have dummy values.
        resetRequiredFields();

        // Make sure delivery method is set.
        $('#edit-shipping-information-shipments input[type="radio"]').prop('checked', true);
      }

      // Expand/collapse checkout guest register form.
      $('.commerce-checkout-register-banner .basket-delivery-banner').once('checkout-guest-register').click(function(){
        $('.basket-delivery-banner').slideUp();
        $('.commerce-checkout-completion-register').slideDown();
      });

      // Add nicescroll to flyout cart.
      $('.cart-block--offcanvas-cart-table--products').once('checkout-flyout-cart-nicescroll').niceScroll({
        autohidemode: 'leave',
        cursoropacitymax: 0.3,
        cursorcolor: '#0473EA',
        cursorwidth: '12px',
        zindex: 99999999,
        railpadding: {
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
        },
      });
      function setFlyoutCartScrollSpace() {
        var otherCartElements = 0;
        otherCartElements += $('.cart--cart-offcanvas__close').outerHeight();
        otherCartElements += $('.cart-block--offcanvas-cart-table--total').outerHeight();
        otherCartElements += $('.cart-block--offcanvas-cart-table--update').outerHeight();
        otherCartElements += $('.basket-delivery-banners').outerHeight();
        document.documentElement.style.setProperty( '--flyout-cart-space', ($('#cart-offcanvas').height() - otherCartElements) + 'px');
      }
      $(window).once('checkout-flyout-cart-nicescroll-resize').resize(function () {
        setFlyoutCartScrollSpace();
      });
      setFlyoutCartScrollSpace();
      if ($('.field--name-field-customer-delivery-date-x input:checked').val() !== 'pick_day') {
        var earliestDay = $('.field--name-field-customer-delivery-date-x').data('earliest-day');
        var earliestMonth = $('.field--name-field-customer-delivery-date-x').data('earliest-month') + 1;
        var setDateAs = (earliestDay < 10 ? '0' : '') + earliestDay + '/' +
          (earliestMonth < 10 ? '0' : '') + earliestMonth + '/' +
          $('.field--name-field-customer-delivery-date-x').data('earliest-year');
        $('.field--name-field-customer-delivery-date input').val(setDateAs);

        $('.field--name-field-customer-delivery-date .checkout-date-picker').datepicker('setDate', new Date(
          $('.field--name-field-customer-delivery-date-x').data('earliest-year'),
          $('.field--name-field-customer-delivery-date-x').data('earliest-month'),
          $('.field--name-field-customer-delivery-date-x').data('earliest-day')
        ));
      }
      let currentDate = new Date(); // Get the current date and time

      let deliveryDate = $('#edit-review-shipping-information .field--name-field-customer-delivery-date .field__item').text();
      let deliveryTime = $('#edit-review-shipping-information .field--name-field-customer-delivery-time .field__item').text();

      let deliveryDateSplit = deliveryDate.split("/");
      let deliveryDateCombined = deliveryDateSplit[1] + "/" + deliveryDateSplit[0] + "/" + deliveryDateSplit[2];

      let deliveryDateTime = new Date(deliveryDateCombined); // Get the delivery date as a Date object

      let tomorrowDate = new Date(currentDate);
      tomorrowDate.setDate(currentDate.getDate() + 1); // Add one day to the current date
      tomorrowDate.setHours(0, 0, 0, 0); // Set the time to midnight for comparison

      let afterTomorrowDate = new Date(currentDate);
      afterTomorrowDate.setDate(currentDate.getDate() + 2); // Add two days to the current date
      afterTomorrowDate.setHours(0, 0, 0, 0); // Set the time to midnight for comparison

      let shippingTotal = false;

      if (deliveryTime.includes('AM') && !deliveryTime.includes('PM')) {
        if(deliveryDateTime.getTime() === tomorrowDate.getTime() && currentDate.getHours() < 12) {
          $('#edit-review-shipping-information .field--name-field-customer-delivery-time .field__item').text('AM (£50 delivery surcharge applies)');
          shippingTotal = "£125.00";
        } else if (deliveryDateTime.getTime() === afterTomorrowDate.getTime() && currentDate.getHours() >= 12) {
          $('#edit-review-shipping-information .field--name-field-customer-delivery-time .field__item').text('AM (£50 delivery surcharge applies)');
          shippingTotal = "£125.00";
        } else {
          if ((deliveryDateTime.getDay() == 1 && currentDate.getDay() == 4 && currentDate.getHours() >= 12) ||
              (deliveryDateTime.getDay() == 1 && currentDate.getDay() == 5 && currentDate.getHours() < 12) ||
              (deliveryDateTime.getDay() == 2 && currentDate.getDay() == 5 && currentDate.getHours() >= 12)) {
            $('#edit-review-shipping-information .field--name-field-customer-delivery-time .field__item').text('AM (£50 delivery surcharge applies)');
            shippingTotal = "£125.00";
          } else {
            $('#edit-review-shipping-information .field--name-field-customer-delivery-time .field__item').text('AM (£30 delivery surcharge applies)');
            shippingTotal = "£30.00";
          }
        }
      }

      if (shippingTotal !== false) {
        $('.field--type-commerce-price .order-total-line__adjustment--shipping .order-total-line-value').text(shippingTotal);
        let subtotal = parseFloat($('.field--type-commerce-price .order-total-line__subtotal .order-total-line-value').text().replace('£', ''));
        let vat = 0.00;
        if ($('.field--type-commerce-price .order-total-line__adjustment--tax .order-total-line-value').length == 1) {
           vat = parseFloat($('.field--type-commerce-price .order-total-line__adjustment--tax .order-total-line-value').text().replace('£', ''));
        }
        let total = parseFloat(shippingTotal.replace('£', '')) + vat + subtotal;
        $('.field--type-commerce-price .order-total-line__total .order-total-line-value').text('£' + total.toFixed(2));
      }

      $('body.page--cart .order-total-line__adjustment--shipping span.order-total-line-value.p.large').text('TBC');

    }
  }; // Drupal.behaviors.checkout_components

})(jQuery, Drupal, drupalSettings);
